module.exports = __webpack_public_path__ + "img/hot_beverage.00ae468a.gif";